import {
  Briefcase, Folder, Rocket, Star, Heart, Target,
  Layers, Users, Globe, Zap, Coffee, Lightbulb,
  Flag, Palette, Shield, Trophy, Megaphone, Package,
  Sparkles, TrendingUp, Calendar, Building2,
} from 'lucide-react';

export const WORKSPACE_ICONS = {
  briefcase: Briefcase,
  folder: Folder,
  rocket: Rocket,
  star: Star,
  heart: Heart,
  target: Target,
  layers: Layers,
  users: Users,
  globe: Globe,
  zap: Zap,
  coffee: Coffee,
  lightbulb: Lightbulb,
  flag: Flag,
  palette: Palette,
  shield: Shield,
  trophy: Trophy,
  megaphone: Megaphone,
  package: Package,
  sparkles: Sparkles,
  'trending-up': TrendingUp,
  calendar: Calendar,
  building: Building2,
};

export const WORKSPACE_ICON_NAMES = Object.keys(WORKSPACE_ICONS);

export const WORKSPACE_ICON_COLORS = [
  '#579bfc', '#e2445c', '#00c875', '#fdab3d', '#a25ddc',
  '#0086c0', '#ff642e', '#cab641', '#66ccff', '#9c27b0',
];

export function defaultColorForWorkspace(id) {
  return WORKSPACE_ICON_COLORS[(id || 0) % WORKSPACE_ICON_COLORS.length];
}
